import {
    Group,
    Stack,
} from '@mantine/core'
import CreateDealButton from './deals-management-buttons/create-deal-btn'
import SegmentControlUpdated from 'app/views/components/segments/segment-control-updated'
import CreateFacilityButton from './deals-management-buttons/create-facility-btn'
import HistoryToggleButton from 'app/views/components/buttons/HistoryToggleButton'
import { Outlet, useLocation } from 'react-router-dom'

export function DealDrillPage() {
    const location = useLocation()
    const isFacilitiesTab = location.pathname.startsWith('/dealmanagement/facilities')

    const tabs = {
        deals: { route: `/dealmanagement`, label: 'DEALS' },
        facilities: { route: `/dealmanagement/facilities`, label: 'FACILITIES' },
    }
    return (
        <Stack w="100%">
            <Group w="100%" position="apart" className='tabsGapsActivity'>
                <Group position="right">
                    <SegmentControlUpdated tabs={tabs} />
                </Group>
                <Group noWrap>
                    <HistoryToggleButton navLink={isFacilitiesTab ? '/dealmanagement/facilities/terminated' : '/dealmanagement/terminated'} />
                    {isFacilitiesTab ? <CreateFacilityButton /> : <CreateDealButton />}
                </Group>
            </Group>
            <Outlet />
        </Stack>
    )
}